<template>
  <div class="w-full flex justify-end">
    <button
        class="text-black mx-2 hover:text-blue-600 font-bold"
        @click="btnClickedHandler"
    >
      <span class="fa fa-print"></span>
    </button>
  </div>
</template>
<script lang="ts">
import {defineComponent} from 'vue'
import {ICellRendererParams} from 'ag-grid-community'
import ZeissCard from '@/models/customer/ZeissCard'

interface ZeissCardCellRendererParams extends ICellRendererParams<ZeissCard> {
  onPrintBtnClicked: (card: ZeissCard) => void
}

export default defineComponent({
  props: {
    params: {
      type: Object as () => ZeissCardCellRendererParams,
      required: true
    }
  },
  methods: {
    btnClickedHandler() {
      if (this.params.data) {
        this.params.onPrintBtnClicked(this.params.data)
      }
    }
  }
})
</script>
